module.exports = __webpack_public_path__ + "img/faculty-jessica.59715796.jpg";